import { Fragment } from "react";
import { Link } from "react-router-dom";

const INLINE = /(\*\*[^*]+\*\*|\[\[DA VERIFICARE:[^\]]*\]\]|\[[^\]]+\]\([^)]+\))/g;

const Verify = ({ text }) => (
  <span data-testid="legal-to-verify" className="inline-block my-1 px-2 py-1 bg-[#956842]/12 border-l-2 border-[#956842] text-[13px] text-[#6b4a2e]">
    <b className="uppercase tracking-[0.15em] text-[10px] mr-1.5">Da verificare</b>{text}
  </span>
);

const inline = (text) =>
  text.split(INLINE).filter(Boolean).map((part, i) => {
    if (part.startsWith("**")) return <strong key={i} className="font-semibold text-[#39251D]">{part.slice(2, -2)}</strong>;
    if (part.startsWith("[[DA VERIFICARE:")) return <Verify key={i} text={part.slice(16, -2).trim()} />;
    const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (m) return m[2].startsWith("/") ? <Link key={i} to={m[2]} className="underline decoration-[#956842] underline-offset-2">{m[1]}</Link> : <a key={i} href={m[2]} className="underline">{m[1]}</a>;
    return <Fragment key={i}>{part}</Fragment>;
  });

const Table = ({ rows }) => {
  const cells = rows.filter((r) => !/^\|[\s|-]+\|$/.test(r)).map((r) => r.split("|").slice(1, -1).map((c) => c.trim()));
  const [head, ...body] = cells;
  return (
    <div className="overflow-x-auto my-5 border border-[#D5B98C]/60" data-testid="legal-table">
      <table className="w-full text-sm min-w-[640px]">
        <thead><tr className="bg-[#E9DFCE]/60">{head.map((h, i) => <th key={i} className="p-2.5 text-left text-[11px] uppercase tracking-[0.12em] text-[#956842]">{h}</th>)}</tr></thead>
        <tbody>{body.map((r, i) => <tr key={i} className="border-t border-[#D5B98C]/40">{r.map((c, j) => <td key={j} className="p-2.5 align-top">{inline(c)}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
};

export const LegalContent = ({ content }) => {
  const blocks = [];
  const lines = content.split("\n");
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trimEnd();
    if (!line.trim()) continue;
    if (line.startsWith("|")) {
      const rows = [];
      while (i < lines.length && lines[i].startsWith("|")) rows.push(lines[i++].trim());
      i--; blocks.push(<Table key={i} rows={rows} />);
    } else if (/^(- |\d+\. )/.test(line)) {
      const ordered = /^\d+\. /.test(line);
      const items = [];
      while (i < lines.length && /^(- |\d+\. )/.test(lines[i])) items.push(lines[i++].replace(/^(- |\d+\. )/, ""));
      i--;
      const Tag = ordered ? "ol" : "ul";
      blocks.push(<Tag key={i} className={`${ordered ? "list-decimal" : "list-disc"} ml-5 space-y-1.5 my-4 marker:text-[#956842]`}>{items.map((it, k) => <li key={k}>{inline(it)}</li>)}</Tag>);
    } else if (line.startsWith("### ")) blocks.push(<h3 key={i} className="font-serif text-xl text-[#39251D] mt-7 mb-2">{inline(line.slice(4))}</h3>);
    else if (line.startsWith("## ")) blocks.push(<h2 key={i} className="font-serif text-2xl sm:text-3xl text-[#39251D] mt-10 mb-3">{inline(line.slice(3))}</h2>);
    else if (line.startsWith("> ")) blocks.push(<p key={i} className="my-4 p-4 bg-[#E9DFCE]/50 italic text-sm">{inline(line.slice(2))}</p>);
    else blocks.push(<p key={i} className="my-3">{inline(line)}</p>);
  }
  return <div className="text-[15px] leading-[1.8] text-[#242321]/85" data-testid="legal-content">{blocks}</div>;
};
